const support = {
  en: {
    support: "Support",
    contactUs: "Contact Us",
    textExplainationContactUs:
      "The Raidstorm team is dedicated to making your online support experience the best it can be. So that we can assist you in the best possible way, please fill in the information requested in the fields on the side. From the opening of the call, you will receive a response within 24 hours.",
    nameSupport: "Name",
    companyName: "Company Name",
    emailSupport: "Email",
    subject: "Subject",
    explanation: "Explaination",
    attachment: "Attachment",
    textAttachment: "Click to find your file or drop it here",
    obrigatoryFields: "Obrigatory Fields",
    placeholderName: "Insert your complete name",
    placeholderEmail: "example{'@'}example.com",
    placeholderCompanyName: "Insert your company name",
    placeholderExplanation:
      "Explain to us the what happened so we can help you",
    placeholderSubject: "Select the reason of contact",
    fieldsSubject: {
      doubt: "Doubt",
      support: "Technical Support",
      solicitation: "Solicitation",
      problem: "Problem"
    },
    titleModalConfirmation: "Trank you for reaching out",
    subtitleModalConfirmation:
      "We'll review your message and get in touch soon, please be patient :)"
  },
  pt: {
    support: "Suporte",
    contactUs: "Contate Nos",
    textExplainationContactUs:
      "A equipe do Raidstorm está dedicada a tornar sua experiência de suporte online a melhor possível. Para que possamos auxiliá-lo da melhor forma possível, por favor, preencha as informações solicitadas nos campos ao lado. A partir da abertura do chamado, você receberá uma resposta dentro de 24 horas.",
    nameSupport: "Nome",
    companyName: "Nome da Companhia",
    emailSupport: "Email",
    subject: "Assunto",
    explanation: "Explicação",
    attachment: "Arquivo",
    textAttachment: "Clique para encontrar seu arquivo ou solte-o aqui",
    obrigatoryFields: "Campos Obrigatórios",
    placeholderName: "Insira seu nome completo",
    placeholderEmail: "exemplo{'@'}exemplo.com",
    placeholderCompanyName: "Insira o nome da sua companhia",
    placeholderExplanation:
      "Explique-nos o que aconteceu para que possamos ajudá-lo",
    placeholderSubject: "Selecione o motivo do contato",
    fieldsSubject: {
      doubt: "Dúvida",
      support: "Suporte Técnico",
      solicitation: "Solicitação",
      problem: "Problema"
    },
    titleModalConfirmation: "Obrigado por entrar em contato",
    subtitleModalConfirmation:
      "Analisaremos sua mensagem e entraremos em contato em breve, seja paciente :)"
  },
  es: {
    support: "Soporte",
    contactUs: "Contacto Con Nosotros",
    textExplainationContactUs:
      "El equipo de Raidstorm se dedica a hacer que su experiencia de soporte en línea sea lo mejor posible. Para que podamos atenderle de la mejor manera posible, por favor rellene los datos solicitada en los campos al costado. Desde la apertura de la convocatoria, recibirá una respuesta en 24 horas.",
    nameSupport: "Nombre",
    companyName: "Nombre de la Empresa",
    emailSupport: "Email",
    subject: "Asunto",
    explanation: "Explicación",
    attachment: "Archivo Adjunto",
    textAttachment: "Haga clic para encontrar su archivo o suéltelo aquí",
    obrigatoryFields: "Campos Obligatorios",
    placeholderName: "Introduzca su nombre completo",
    placeholderEmail: "ejemplo{'@'}ejemplo.com",
    placeholderCompanyName: "Introduzca el nombre de su empresa",
    placeholderExplanation: "Explícanos lo sucedido para que podamos ayudarte",
    placeholderSubject: "Seleccione el motivo del contacto",
    fieldsSubject: {
      doubt: "Duda",
      support: "Soport Técnico",
      solicitation: "Solicitud",
      problem: "Problema"
    },
    titleModalConfirmation: "Gracias por contactarte",
    subtitleModalConfirmation:
      "Revisaremos su mensaje y nos pondremos en contacto pronto, tenga paciencia :)"
  }
}

export default support
